import React from 'react';
import { format } from 'date-fns';
import { isEqual } from 'lodash';
import { DATE_FORMAT } from '@cyberint/common-utils';
import { Tag, TagVariants } from '../../Tag';
import { IconSizes } from '../../Icons';
import * as S from './styled';

const { MMM_DD_YYYY_FORMAT } = DATE_FORMAT;

const getOption = (v, options) => options?.find(o => o.value === v || isEqual(v, o.mappedValue));

const Category = ({ label, clearAll, testId }) => (
  <S.CategoryWrapper>
    {!!clearAll && <S.CloseIcon data-testid={testId} onClick={clearAll} fontSize={IconSizes.XS} />}
    <S.FieldName>{label}:</S.FieldName>
  </S.CategoryWrapper>
);

export const MultiValuesChips = ({ label, value, clear, options, field, clearAll, variant = TagVariants.CHIP }) =>
  Array.isArray(value) && value.length > 0 ? (
    <>
      {label && <Category label={label} clearAll={clearAll} testId={`button-clearAll-${field}-chips`} />}
      {value.map(v => {
        const option = getOption(v, options);
        return (
          <Tag
            key={v}
            icon={option?.icon}
            dotColor={option?.dotColor}
            content={option?.label || v}
            testId={`${v}-chip`}
            onClose={clear ? () => clear(v) : undefined}
            variant={variant}
          />
        );
      })}
    </>
  ) : null;

export const SingleValueChip = ({ label, field, value, clear, options }) => {
  if (value != null) {
    const option = getOption(value, options);
    return (
      <>
        <S.FieldName>{label}:</S.FieldName>
        <Tag
          icon={option?.icon}
          dotColor={option?.dotColor}
          content={option?.label || value}
          testId={`${field}-chip`}
          onClose={clear}
          variant={TagVariants.CHIP}
        />
      </>
    );
  }
  return null;
};

export const RangeChip = ({ label, field, value, clear }) =>
  value?.from && value?.to ? (
    <>
      <S.FieldName>{label}:</S.FieldName>
      <Tag
        content={
          value.option?.label ||
          `${format(new Date(Number(value.from)), MMM_DD_YYYY_FORMAT)} - ${format(
            new Date(Number(value.to)),
            MMM_DD_YYYY_FORMAT
          )}`
        }
        testId={`${field}-chip`}
        onClose={clear}
        variant={TagVariants.CHIP}
      />
    </>
  ) : null;
